import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components';
import { homeBannerSchema } from './schema';
import { useIntl } from 'react-intl';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock, schemaEnhancer } = props;
  const blockConfig = blocksConfig[data['@type']];
  // `dataAdapter` é opcional; sem ele, grava o valor direto no bloco.
  const dataAdapter =
    blockConfig?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intl = useIntl();
  const schema = schemaEnhancer
    ? schemaEnhancer(homeBannerSchema({ ...props, intl }), props)
    : homeBannerSchema({ ...props, intl });

  return (
    <>
      <BlockDataForm
        schema={schema}
        title={schema.title}
        onChangeField={(id, value) => {
          dataAdapter({
            block,
            data,
            id,
            onChangeBlock,
            value,
          });
        }}
        onChangeBlock={onChangeBlock}
        formData={data}
        block={block}
      />
    </>
  );
};

Data.propTypes = {
  block: PropTypes.string.isRequired,
  blocksConfig: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  schemaEnhancer: PropTypes.func,
};

export default withObjectBrowser(Data);
